import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IPricingProfileAdminUser } from 'pricing/types';

export const getPricingProfileAdminUsers = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/corporate/pricing-profile/corporate-users?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IPricingProfileAdminUser>(data.data, data.recordsFiltered);
};

export const upsertPricingProfileAdminUser = async (data: Record<string, unknown>) => {
  return partfinitiClient.postForm('/corporate/pricing-profile/save-corporate-user', data);
};

export const removePricingProfileAdminUsers = async (data: { ids: number[] }) => {
  return partfinitiClient.postForm('/corporate/pricing-profile/remove-corporate-users', data);
};
